import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { TiUserAdd } from "react-icons/ti";
import { TiUserDelete } from "react-icons/ti";
import { buildApiUrl } from "../utils/api";

function AdminTable() {
    const [userData, setUserData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: ''
    });

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await axios.get(buildApiUrl('/api/admin/getAdminUser'));
                setUserData(response.data); // Assuming the response contains the admin logins
            } catch (error) {
                console.error('Error fetching User data:', error);
            }
        };

        fetchUserData();
    }, []);
    // Toggle modal visibility
    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    // Handle form input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(buildApiUrl('/api/admin/register'), formData);
            if (response.status === 200) {
                alert('User added successfully!');
                handleClose(); // Close modal after successful submission
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error adding user');
        }
    };
    // Function to handle deleting the user by email
    const handleDeleteUser = async (email) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this user?");
        if (confirmDelete) {
            try {
                // Making a DELETE request to backend API
                const response = await axios.delete(buildApiUrl('/api/admin/delete'), {
                    data: { email } // Send email in the request body
                });

                if (response.status === 200) {
                    alert('User deleted successfully!');

                    // Update the UI by removing the deleted user from the state
                    setUserData(userData.filter(user => user.email !== email));
                }
            } catch (error) {
                console.error("Error deleting user:", error);
                alert("Failed to delete the user");
            }
        }
    };


    return (
        <div className="table-responsive">
            <table className="table table-bordered table-striped">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Password</th>
                        <th>Role</th>
                        {/* <th>Last Login</th> */}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {userData.map((user, index) => (
                        <tr key={index}>
                            <td>{user._id}</td>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.password}</td>
                            <td>Admin </td>
                            {/* <td>{user.lastLogin}</td> */}
                            <td>
                                <button className='btn btn-danger' style={{ width: "140px" }} onClick={() => handleDeleteUser(user.email)}>
                                    <TiUserDelete style={{ fontSize: "25px" }} /> Delete User
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className='addadmin'>
                <button className='btn btn-success' onClick={handleShow}><TiUserAdd style={{ fontSize: "25px" }} /> Add User</button>
                {/* <button className='btn btn-danger' onClick={() => handleDeleteUser(user.email)} style={{ marginLeft: "20px" }}><TiUserDelete style={{ fontSize: "25px" }} /> Delete User</button> */}
                {/* Bootstrap Modal */}
                {showModal && (
                    <div className='modal show d-block' style={{ marginTop: "10%", marginLeft: "50px" }} tabIndex='-1'>
                        <div className='modal-dialog'>
                            <div className='modal-content py-4'>
                                <div className='modal-header' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <h5 className='modal-title' style={{ color: '#E0A75E', fontSize: 'x-large' }}>Add New Admin</h5>
                                    <button type='button' className='close' onClick={handleClose} style={{ marginLeft: 'auto' }}>
                                        <span>&times;</span>
                                    </button>
                                </div>

                                <div className='modal-body text-start'>
                                    <form onSubmit={handleSubmit}>
                                        <div className='form-group mt-2'>
                                            <label>Name</label>
                                            <input
                                                type='text'
                                                className='form-control'
                                                name='name'
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className='form-group mt-2'>
                                            <label>Email</label>
                                            <input
                                                type='email'
                                                className='form-control'
                                                name='email'
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className='form-group mt-2'>
                                            <label>Password</label>
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                className='form-control'
                                                name='password'
                                                value={formData.password}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="d-flex align-items-center mt-2">
                                            <input
                                                type="checkbox"
                                                id="showPassword"
                                                onClick={() => setShowPassword(!showPassword)}
                                            />
                                            <label htmlFor="showPassword" className="ms-2">
                                                {showPassword ? "Hide Password" : "Show Password"}
                                            </label>
                                        </div>
                                        <button type='submit' className='btn btn-primary mt-3'>
                                            Add Now
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default AdminTable;
